var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-have-examine"},[_c('examineModel',_vm._g({attrs:{"examineType":_vm.type}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }